module.exports = __webpack_public_path__ + "img/icn_logout_v1.5570c28f.svg";